import AppCard from '@nxsys/components/AppCard';
import AppCardTabListContainer from '@nxsys/components/AppCardTabListContainer';
import AppPageTitle from '@nxsys/components/AppPageTitle';
import AppsContainer from '@nxsys/components/AppsContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { useCallback, useState } from 'react';
import NormalTab from './components/NormalTab';
import { PSR_SUBMIT_TYPE } from '@nxsys/constants/psr';
import LeaverTab from './components/LeaverTab';

type Props = {
  cbAfterAction?: () => void;
  isDashboard?: boolean;
};

const SubmitPSR: React.FC<Props> = ({ cbAfterAction, isDashboard = false }) => {
  const { messages } = useTypedIntl();

  const tabs = [
    { tab: messages['psr.submit.normalTab'], key: PSR_SUBMIT_TYPE.NORMAL },
    { tab: messages['psr.submit.leaverTab'], key: PSR_SUBMIT_TYPE.LEAVER },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0]?.key);

  const renderTitle = useCallback(() => {
    return (
      <AppPageTitle
        prefix={messages['psr.submit.title']}
        separator=""
        title={''}
      />
    );
  }, [messages]);

  const renderContent = useCallback(() => {
    return (
      <AppCardTabListContainer
        tabList={tabs}
        activeTab={activeTab}
        handleTabChange={(
          key: (typeof PSR_SUBMIT_TYPE)[keyof typeof PSR_SUBMIT_TYPE],
        ) => setActiveTab(key)}
        {...isDashboard && { className: '!border-none' }}
      >
        {activeTab === PSR_SUBMIT_TYPE.NORMAL && (
          <NormalTab cbAfterAction={cbAfterAction} />
        )}
        {activeTab === PSR_SUBMIT_TYPE.LEAVER && (
          <LeaverTab cbAfterAction={cbAfterAction} />
        )}
      </AppCardTabListContainer>
    );
  }, [isDashboard, activeTab, cbAfterAction]);

  if (isDashboard) {
    return renderContent();
  }

  return (
    <AppsContainer fullView type="bottom" title={renderTitle()}>
      <AppCard>
        {renderContent()}
      </AppCard>
    </AppsContainer>
  );
};

export default SubmitPSR;
